export default {
  index( params = {}, options = {}) {
    return Vue.http.get(
      `calltrackings/lambdaFunctions`,
      {params, ...options}
    ).then(response => response.data)
  }
}
